import React from "react";
import { ReadOnlyProps } from "../../../utils/templates";
import { TouchableOpacity, StyleSheet } from "react-native";

import { renameLabel } from "../../../utils/common";
import { Text } from "react-native";

interface Props {
  itemsList: Array<string>;
  filterCategory: string;
  setFilterCategory: (category: string) => void;
}

export const BadgeHorizontalList: React.FC<Props> = (
  props: ReadOnlyProps<Props>
) => {
  return (
    <>
      {props.itemsList.map((item) => {
        return (
          <TouchableOpacity
            key={item}
            style={[
              styles.filterButton,
              props.filterCategory === item && styles.activeFilterButton,
            ]}
            onPress={() => props.setFilterCategory(item)}
          >
            <Text
              style={
                props.filterCategory === item
                  ? styles.activeFilterText
                  : styles.filterText
              }
            >
              {renameLabel(item)}
            </Text>
          </TouchableOpacity>
        );
      })}
    </>
  );
};

const styles = StyleSheet.create({
  filterButton: {
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: "#F1F5F9",
    borderRadius: 999,
    marginRight: 8,
    marginBottom: 6,
    borderWidth: 1,
    borderColor: "#E2E8F0",
  },
  activeFilterButton: {
    backgroundColor: "#61B8FF",
    borderColor: "#61B8FF",
  },
  filterText: {
    fontSize: 13,
    color: "#475569",
    fontWeight: "500",
  },
  activeFilterText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },
});
